import { render, staticRenderFns } from "./InqCert.vue?vue&type=template&id=cf7a16ce&scoped=true"
import script from "./InqCert.vue?vue&type=script&lang=js"
export * from "./InqCert.vue?vue&type=script&lang=js"
import style0 from "./InqCert.vue?vue&type=style&index=0&id=cf7a16ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf7a16ce",
  null
  
)

export default component.exports